export default __webpack_public_path__ + "static/media/e-sus-negative.e10ff36b.svg";